import React from 'react';
import Header from './components/home/Header';
import Hero from './components/home/Hero';
import Features from './components/home/Features';
import Footer from './components/home/Footer';
import './index.css';

function App() {
  return (
    <div className="w-full min-h-screen bg-neutral-900">
      <Header />
      <Hero />
      <Features />
      <Footer />
    </div>
  );
}

export default App;